"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Annotation, CoreModel } from "@ym-framework/model";
import { DataSetModel } from "@/models/dataset.model";
import { TagsModel } from "@/models/tags.model";
export let VirtualdesktopModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
    this.name = "";
    this.open_time = 0;
    this.type = "";
    this.config = new ConfigModel();
    this.osName = "";
    this.ip = "";
    this.region = new RegionModel();
    this.canUseDays = 0;
    this.goodsEndDate = 0;
    this.autoRenew = false;
    this.status = "";
    this.shops = new DataSetModel();
    this.marks = new TagsModel();
    this.admins = new DataSetModel();
    this.canUseSeconds = 0;
    this.renewPrice = 0;
    this.expired_time = 0;
    // file_uids?:string[] = [];
    this.fileUid = [];
    // file_num?:number = 0;
    this.fileNum = 0;
    this.button = new ButtonModel();
    this.currency = "";
    this.estimateOpeningTime = 0;
    this.ipAlias = "";
  }
};
VirtualdesktopModel.model = "virtualdesktop";
VirtualdesktopModel = __decorateClass([
  Annotation.ModelMeta
], VirtualdesktopModel);
export let ButtonModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.button = "";
    this.disabled = false;
  }
};
ButtonModel.model = "button.status";
ButtonModel = __decorateClass([
  Annotation.ModelMeta
], ButtonModel);
export let ConfigModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.os = "";
    this.language = "";
    this.language_name = "";
    this.country = "";
    this.timezone = "";
    this.browser = new BrowserModel();
    this.useragent = "";
    this.unify_os = false;
    this.operating_system = false;
  }
};
ConfigModel.model = "virtualdesktop.config";
ConfigModel = __decorateClass([
  Annotation.ModelMeta
], ConfigModel);
export let BrowserModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.name = "";
    this.version = "";
  }
};
BrowserModel.model = "virtualdesktop.config.browser";
BrowserModel = __decorateClass([
  Annotation.ModelMeta
], BrowserModel);
export let OsModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.windows = "";
    this.mac = "";
    this.android = "";
    this.linux = "";
    this.unify = "";
  }
};
OsModel.model = "virtualdesktop.config.os";
OsModel = __decorateClass([
  Annotation.ModelMeta
], OsModel);
export let RegionModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
    this.name = "";
    this.area = "";
    this.group = "";
    this.category = "";
    this.has_config = false;
    this.serviceProvider = "";
  }
};
RegionModel.model = "virtualdesktop.region";
RegionModel = __decorateClass([
  Annotation.ModelMeta
], RegionModel);
export let VirtualDesktopBriefProModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
    this.name = "";
    this.address = "";
    this.shopNumber = 0;
  }
};
VirtualDesktopBriefProModel.model = "virtualdesktop.pro";
VirtualDesktopBriefProModel = __decorateClass([
  Annotation.ModelMeta
], VirtualDesktopBriefProModel);
export let VirtualDesktopProModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
    this.oldId = "";
    this.name = "";
    this.address = "";
    this.addressAlias = null;
    this.expiredTime = 0;
    this.autoRenew = false;
    this.type = "";
    this.status = "";
    this.canUseDays = 0;
    this.canUseSeconds = 0;
    this.price = 0;
    this.currency = "";
    this.adminCount = 0;
    this.fileCount = 0;
    this.osName = "";
    this.osVersion = "";
    this.shops = new DataSetModel();
    this.region = new RegionModel();
    this.marks = new TagsModel();
    this.expectOpenTime = 0;
  }
};
VirtualDesktopProModel.model = "virtualdesktop.pro";
VirtualDesktopProModel = __decorateClass([
  Annotation.ModelMeta
], VirtualDesktopProModel);
export let VirtualDesktopDetailModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
    this.name = "";
    this.openTime = 0;
    this.type = "";
    this.config = new VirtualDesktopConfig();
    this.address = "";
    this.region = new VirtualRegion();
    this.canUseDays = 0;
    this.status = "";
    this.marks = new TagsModel();
    this.owners = new DataSetModel();
    this.canuseSeconds = 0;
    this.expiredTime = 0;
  }
};
VirtualDesktopDetailModel.model = "virtualdesktop.detail";
VirtualDesktopDetailModel = __decorateClass([
  Annotation.ModelMeta
], VirtualDesktopDetailModel);
export let VirtualDesktopConfig = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.os = "";
    this.language = "";
    this.country = "";
    this.timezone = "";
    this.browser = new VirtualDesktopBrowser();
    this.useragent = "";
    this.unifyOs = false;
    this.operatingSystem = new VdOperation();
    this.languageName = "";
    this.screen = "";
    this.resolutionMode = "";
  }
};
VirtualDesktopConfig.model = "virtualdesktop.config";
VirtualDesktopConfig = __decorateClass([
  Annotation.ModelMeta
], VirtualDesktopConfig);
export let VirtualDesktopBrowser = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.name = "";
    this.version = "";
    this.code = "";
  }
};
VirtualDesktopBrowser.model = "browser";
VirtualDesktopBrowser = __decorateClass([
  Annotation.ModelMeta
], VirtualDesktopBrowser);
export let VdOperation = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.windows = "";
    this.mac = "";
    this.android = "";
    this.linux = "";
  }
};
VdOperation.model = "operation";
VdOperation = __decorateClass([
  Annotation.ModelMeta
], VdOperation);
export let VirtualRegion = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
    this.name = "";
  }
};
VirtualRegion.model = "region";
VirtualRegion = __decorateClass([
  Annotation.ModelMeta
], VirtualRegion);
